import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleCheck } from '@fortawesome/free-solid-svg-icons';
import { FormWrapper, Label, Button, Input } from '../forms/shared_form_styles';
import { Row, Column } from '../forms/shared_details_form_styles';
import { markAttendance } from '../actions/attendanceActions';
import styled from 'styled-components';

const AttendanceRow = styled(Row)`
  @media (max-width: 550px) {
    flex-direction: column;
  }
`;

const AttendanceColumn = styled(Column)`
  @media (max-width: 550px) {
    width: 100%;
  }
`;
const Note = styled.span`
  display: block;
  font-size: 0.875em; 
  font-weight:100;
  color: #555; 
`;

export const MarkAttendance = () => {
  const attendancesArray = useSelector((state) => state.attendances ? state.attendances : null);
  const [studentDocument, setStudentDocument] = useState("");
  const [code, setCode] = useState("");
  const [result, setResult] = useState("");
  const [error, setError] = useState(null);
  const [isSaving, setIsSaving] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);

  useEffect(() => {
    const savedAttendance = attendancesArray.filter(at => at.student.document === studentDocument);
    if (code !== "") {
      if (savedAttendance.length > 0 && savedAttendance[0].student && savedAttendance[0].student.name) {
        setIsSaving(false);
        setResult(`Se ha marcado la asistencia de ${savedAttendance[0].student.name} correctamente`);
        setStudentDocument("");
        setCode("");
      } 
    }
  }, [attendancesArray, studentDocument, code]);

  const dispatch = useDispatch();

  const handleSave = async () => {
    setIsSubmitted(true);
    if (studentDocument !== "" && code !== "") {
      try {
        setIsSaving(true);
        await dispatch(markAttendance({ studentDocument, code }));
        // Clear the input fields on success
        setStudentDocument("");
        setCode("");
        setError(null); // Clear any previous error
      } catch (error) {
        setError(`An error has occurred. Please email a screenshot where the time is visible to the professor (error: ${error.message})`);
      } finally {
        setIsSaving(false); // Ensure isSaving is reset
      }
    }
  };

  return (
    <FormWrapper>
      <AttendanceRow style={{ height: '40%' }}>
        <AttendanceColumn>
          <Label>
            Student ID:
            <Input
              type="text"
              name="studentDocument"
              value={studentDocument}
              onChange={(e) => setStudentDocument(e.target.value)}
            />
             <Note>(without punctuation characters)</Note>
          </Label>
          <Label>
            Codigo:
            <Input
              type="text"
              name="code"
              value={code}
              onChange={(e) => setCode(e.target.value)}
            />
          </Label>
          <Button disabled={isSaving} onClick={handleSave}>Save</Button>
        </AttendanceColumn>
        <AttendanceColumn style={{ display: 'flex', justifyContent: 'center', padding: '5%', textAlign: 'center' }}>
          {isSubmitted && (error || result) && (
            <Label style={{ color: error ? 'red' : 'green' }}>
              {error || (result && (
                <>
                  <FontAwesomeIcon icon={faCircleCheck} style={{ color: 'green' }} />
                  {result}
                </>
              ))}
            </Label>
          )}
        </AttendanceColumn>
      </AttendanceRow>
    </FormWrapper>
  );
};

export default MarkAttendance;
